var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"loader-wrapper fixed inset-0 flex justify-center items-center z-50 bg-blue-900 bg-opacity-90"},[_c('div',{staticClass:"app-loader"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }